/**
 * Redux Typed Hooks
 *
 * This file provides typed versions of the useDispatch and useSelector hooks for Redux.
 * Use these hooks throughout your app instead of the plain versions to get proper TypeScript
 * type inference for dispatch and state selection.
 *
 * Exports:
 * - useAppDispatch: Typed version of useDispatch for the app's dispatch type
 * - useAppSelector: Typed version of useSelector for the app's root state
 */

import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from ".";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
